import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import ApproveMoviePerson from './ApproveMoviePerson'
import AutoSuggestionsmovieID from './AutoSuggestionsmovieID'
import English from './English'
import EnglishandTeluguFields from './EnglishandteField'
import GalleryImages from './GalleryImages'
import GalleryVideos from './GalleryVideos'
import ImportMovies from './Importmovie'
import LoadingSpinner from './Loading'
import RadioButtonmovieswebseries from './RadioButtonmovieswebseries'
import GoatAndPopular from './GoatAndPopular'
import ApproveCreateMoviePerson from './ApproveCreateMoviePerson'

export default function Uicomponentmovie(props) {
  //
  const {
    inputData,
    handlecontentTypeChange,
    editData,
    modeUrl,
    pkvalue,
    BooleanValueforDisplayiingUi,
    pkvalueinput,
    editRender,
    isLoading,
    active,
    handleActiveChange,
    movieData,
    moviePersons,
    BooleanValueChangeDone,
    sendBooleanValueChangeDone,
    updateInputData,
    sendinputdata,
    updateButtondisable,
    submitEditMovie,
    setIsLoading,
    EDitApproveOptionBoolean,
    loadPopup,
    setLoadPopup,
    setHorizontalImage,
    setmoviedata,
    editOttAndNewsPermission,
    DeleteOttAndNewsPermission,
    ApproveOttAndNewsPermission,
  } = props

  return (
    <div
      className='displaySidebySide'
      /* style={{ display: 'flex' }} */
    >
      {modeUrl ? (
        <></>
      ) : (
        <div>
          {!BooleanValueforDisplayiingUi && (
            <AutoSuggestionsmovieID
              pkvalue={pkvalue}
              pkvalueinput={pkvalueinput}
              editRender={editRender}
            />
          )}
        </div>
      )}
      {isLoading && <LoadingSpinner />}
      {(modeUrl || (pkvalue && BooleanValueforDisplayiingUi)) && (
        <Row>
          <Col md={6} xs={12}>
            <div style={{ width: '520px' }}>
              {modeUrl ? <></> : <div style={{ height: '50px' }}></div>}
              <RadioButtonmovieswebseries
                inputData={inputData}
                handlecontentTypeChange={handlecontentTypeChange}
              />
              <div
                className='movie1'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'inherit',
                  position: 'relative',
                }}
              >
                <div className='movie p-3'>
                  <div className='createmovie'>
                    {inputData.contentType === 'movies' ? 'Edit Movie' : 'Edit Webseries'}
                  </div>
                  <form style={{ width: '100%' }}>
                    <Container>
                      <GoatAndPopular
                        inputData={inputData}
                        Popular={inputData.popularMovie}
                        sendInputData={sendinputdata}
                        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                        GOAT={inputData.GOAT}
                        originalLanguageTelugu={inputData.originalLanguageTelugu}
                      />

                      <EnglishandTeluguFields
                        editData={editData ? editData : {}}
                        modeUrl={modeUrl}
                        active={active}
                        movieMode={'edit'}
                        handleActiveChange={handleActiveChange}
                        movieData={movieData}
                        inputData={inputData}
                        moviePersons={moviePersons}
                        BooleanValueChangeDone={BooleanValueChangeDone}
                        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                        updateInputData={updateInputData}
                        sendinputdata={sendinputdata}
                        setIsLoading={setIsLoading}
                        editOttAndNewsPermission={editOttAndNewsPermission}
                        DeleteOttAndNewsPermission={DeleteOttAndNewsPermission}
                        ApproveOttAndNewsPermission={ApproveOttAndNewsPermission}
                      />
                      <English
                        mode={'edit'}
                        editData={editData ? editData : {}}
                        modeUrl={modeUrl}
                        active={active}
                        handleActiveChange={handleActiveChange}
                        movieData={movieData}
                        inputData={inputData}
                        BooleanValueChangeDone={BooleanValueChangeDone}
                        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                        updateInputData={updateInputData}
                        sendinputdata={sendinputdata}
                      />
                      <GalleryImages
                        setHorizontalImage={setHorizontalImage}
                        inputData={inputData}
                        ImageType={'movie'}
                        GalleryImages={inputData.GalleryImages}
                        sendinputdata={sendinputdata}
                        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                      />
                      <GalleryVideos
                        inputData={inputData}
                        GalleryVideos={inputData.GalleryVideos}
                        sendinputdata={sendinputdata}
                        sendBooleanValueChangeDone={sendBooleanValueChangeDone}
                      />
                      <br />
                    </Container>
                  </form>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      className='btn btn-primary'
                      disabled={updateButtondisable()}
                      onClick={() => submitEditMovie()}
                    >
                      {inputData.contentType === 'movies' ? 'Update Movie' : 'Update Webseries'}
                    </button>
                  </div>
                  <span>* mandatory to submit</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {!modeUrl && inputData.wikilink ? (
        <Col md={6} xs={12} className='urlcheck'>
          <ImportMovies
            editData={inputData}
            wikilink={inputData.wikilink}
            contentType={inputData.contentType}
            // sendcss={sendcss}
            setIsLoading={setIsLoading}
            sendEditdata={sendinputdata}
            sendBooleanValueChangeDone={sendBooleanValueChangeDone}
            editMovieData={movieData}
            sendmovieData={setmoviedata}
          />
        </Col>
      ) : (
        <></>
      )}
      {EDitApproveOptionBoolean && movieData && movieData.status === 'draft' && (
        <ApproveCreateMoviePerson
          loadPopup={loadPopup}
          setLoadPopup={setLoadPopup}
          moviePerson={'movie'}
          movieData={movieData}
          sendTFIDBPN={inputData.sendTFIDBPN}
        />
      )}
    </div>
  )
}
